import { useSelector } from 'react-redux';
import { reversedPhoneNumberFormatter } from '../functions/phoneNumberFormatter';
import { selectInputs } from '../redux/inputsReducer';
import { selectAppConfig } from '../redux/appConfigReducer';
import { IS_T1_PAGE } from '../constants/environment';

const useInputsValidator = () => {
  const {
    firstName,
    lastName,
    email,
    zipCode,
    phoneNumber,
    preferredContactMethod,
    ccpa,
    topicOfInterest,
    tradeInVehicleMake,
    tradeInVehicleModel,
    tradeInVehicleYear,
    tradeInVehicleMileage,
    tradeInVehicleVin,
    modelFamilyOfInterest,
    universalConsent,
    preferedBookingTime,
  } = useSelector(selectInputs);

  const { presetForm, market, vehicleId, dealerConsent } = useSelector(selectAppConfig);

  const isUSMarket = market?.toLowerCase().includes('us');

  const isCaliforniaZip = Number(zipCode) >= 90001 && Number(zipCode) <= 96162;

  const isPhoneNumberValid =
    preferredContactMethod === 'email' || reversedPhoneNumberFormatter(phoneNumber).length === 10;

  const isEmailValid =
    email.trim() !== '' && /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(email);

  const isUSZipCodeValid = zipCode.trim() !== '' && /^[0-9]{5}(-[0-9]{4})?$/i.test(zipCode);

  const isCAPostalCodeValid =
    zipCode.trim() !== '' && /^[A-Za-z]\d[A-Za-z][ -]?\d[A-Za-z]\d$/i.test(zipCode);

  const isCcpaValid = isCaliforniaZip ? ccpa : true;

  const isTradeInForm = presetForm === 'tradeIn';
  const isTestDriveForm = presetForm === 'testDrive';
  const isGenericForm = presetForm === 'generic' || presetForm === 'general';

  const isTopicOfInterestValid = !isGenericForm || topicOfInterest.trim() !== '';

  const isUniversalConsentNeeded = !dealerConsent && (isUSMarket || IS_T1_PAGE);
  const isUniversalConcentChecked = isUniversalConsentNeeded && universalConsent;

  const isModelFamilyValid = vehicleId ? true : !!modelFamilyOfInterest;

  const isTradeInVehicleValid = () => {
    const isYearValid = /^\d{4}$/.test(tradeInVehicleYear.trim());
    const isMileageValid = /^\d+$/.test(tradeInVehicleMileage.trim());
    const isVinValid = tradeInVehicleVin.trim() === '' || tradeInVehicleVin.trim().length === 17;

    return (
      tradeInVehicleModel.trim() !== '' &&
      isYearValid &&
      isMileageValid &&
      isVinValid &&
      tradeInVehicleMake.trim() !== '' &&
      isModelFamilyValid
    );
  };

  const isValidForm = () => {
    const isValid =
      firstName.trim() !== '' &&
      lastName.trim() !== '' &&
      isEmailValid &&
      (isUSMarket ? isUSZipCodeValid : isCAPostalCodeValid) &&
      isPhoneNumberValid &&
      isCcpaValid &&
      isTopicOfInterestValid &&
      (!isTradeInForm || isTradeInVehicleValid()) &&
      (!isTestDriveForm || (isModelFamilyValid && preferedBookingTime.trim() !== ''));

    const consent = isUniversalConsentNeeded ? isUniversalConcentChecked : true;

    return isValid && consent;
  };

  return isValidForm;
};

export default useInputsValidator;
